import { createWebHistory, createRouter } from 'vue-router'
import Podcast from './components/Podcast.vue'
import AboutEn from './components/AboutEn.vue'

const Frontpage = () => import('./components/Frontpage.vue')
const Article = () => import('./components/Article.vue')
const About = () => import('./components/About.vue')
const Tip = () => import('./components/Tip.vue')
const Search = () => import('./components/Search.vue')
const Support = () => import('./components/Support.vue')
const Ethics = () => import('./components/Ethics.vue')
const ContentUsage = () => import('./components/ContentUsage.vue')
const Gdpr = () => import('./components/Gdpr.vue')
//const dveDane = () => import('./components/2dane.vue')
const DvePercenta = () => import('./components/DvePercenta.vue')
const JournalisticAwards = () => import('./components/JournalisticAwards.vue')
const Cookies = () => import('./components/Cookies.vue')


const router = createRouter({
    // use browser history for an SPA so navigation updates the URL and works with the dev server
    // createMemoryHistory keeps navigation in-memory (no address bar updates) — use web history
    history: createWebHistory(),
    routes: [
        {
            path: '/about',
            name: 'About',
            component: About
        },
        {
            path: '/search/:search',
            name: 'Search',
            component: Search
        },
        // article routes that start with a numeric id or a 40-character alphanumeric id, e.g. /226/Podporte-nas or /a1b2c3.../Podporte-nas
        {
            path: '/:id(\\d+|[A-Za-z0-9]{40})/:slug(.*)?',
            name: 'Article',
            component: Article,
            props: true
        },
        {
            path: '/tip',
            name: 'Tip',
            component: Tip
        },
        {
            path: '/podporit',
            name: 'Support',
            component: Support
        },
        {
            path: '/ethics',
            name: 'Ethics',
            component: Ethics
        },
        {
            path: '/content-usage',
            name: 'ContentUsage',
            component: ContentUsage
        },
        /*
        {
          path: '/2-percenta-dani',
          name: '2dane',
          component: dveDane
        },*/
        {
            path: '/darujte-2-percenta',
            name: 'DvePercenta',
            component: DvePercenta
        },
        {
            path: '/gdpr',
            name: 'Gdpr',
            component: Gdpr
        },
        {
            path: '/article-test/:articleUID',
            name: 'Test článkov',
            props: true,
            component: Article
        },
        {
            path: '/podcast',
            name: 'Podcast',
            component: Podcast
        },
        {
            path: '/about-en',
            name: 'About(English)',
            component: AboutEn
        },
        {
            // catch-all -> frontpage
            path: '/:pathMatch(.*)*',
            name: 'Frontpage',
            component: Frontpage
        },
        {
            path: '/novinarske-ceny',
            name: 'JournalisticAwards',
            component: JournalisticAwards
        },
        {
            path: '/cookies',
            name: 'Cookies',
            component: Cookies
        },
    ]
})

export default router
